import { makeStyles } from '@mui/styles';
import Skeleton from '@classify/react-core-components/Skeleton';

const useStyles = makeStyles(({ spacing }) => ({
  divider: {
    height: 20,
    width: '100%',
  },
  largeDivider: {
    height: 36,
    width: '100%',
  },
  title: {
    display: 'block',
    height: 32,
    width: '58%',
    marginBottom: spacing(3),
  },
  item: {
    height: 16,
    width: '100%',
    display: 'block',
    marginBottom: spacing(1),
  },
}));

const SinglePageCourseContentSkeleton = () => {
  const classes = useStyles();

  return (
    <div data-testid="courseContentSkeleton">
      <Skeleton classes={{ root: classes.title }} />
      <Skeleton count={3} classes={{ root: classes.item }} />
      <Skeleton height={16} width="50%" />
      <div className={classes.divider} />
      <Skeleton count={3} classes={{ root: classes.item }} />
      <Skeleton height={16} width="50%" />
      <div className={classes.largeDivider} />
      <Skeleton classes={{ root: classes.title }} />
      <Skeleton count={3} classes={{ root: classes.item }} />
      <Skeleton height={16} width="50%" />
    </div>
  );
};

export default SinglePageCourseContentSkeleton;
